import { useSubscription } from '@apollo/react-hooks';
import DEMOGRAPH_JOB_PROGRESS_SUBSCRIPTION from '../GraphQl/Subscriptions/DEMOGRAPH_JOB_PROGRESS_SUBSCRIPTION';

const useDemographJobProgress = (orgId, { updateJobStatus, clearJobStatus, onJobCompleted }) => {
  const { error } = useSubscription(
    DEMOGRAPH_JOB_PROGRESS_SUBSCRIPTION,
    {
      variables: { orgId },
      skip: !orgId,
      onSubscriptionData: ({ subscriptionData }) => {
        if (subscriptionData?.data?.demographJobProgress) {
          const update = subscriptionData.data.demographJobProgress;
          if (update.status === 'COMPLETED') {
            updateJobStatus(update.audienceDemographId, update);
            // Refetch data so Apollo cache gets updated DB flags
            if (onJobCompleted) onJobCompleted();
            setTimeout(() => clearJobStatus(update.audienceDemographId), 10000);
          } else if (update.status === 'FAILED') {
            updateJobStatus(update.audienceDemographId, update);
            if (onJobCompleted) onJobCompleted();
          } else {
            updateJobStatus(update.audienceDemographId, update);
          }
        }
      },
      onError: (err) => {
        console.error('Demograph job progress subscription error:', err);
      },
    }
  );

  return { error };
};

export default useDemographJobProgress;
